export type CCBStage = "S1" | "S2" | "S3" | "S4" | "S5" | "S6" | "S7" | "S8";

export interface CCBSkill {
  slug: string;
  label: string;
  description: string;
  stage: CCBStage;
  isNew?: boolean;
}

export const STAGE_META: Record<CCBStage, { label: string; color: string; bg: string; text: string }> = {
  S1: { label: "Research & Discovery",       color: "#3B82F6", bg: "bg-blue-100 dark:bg-blue-900/30",   text: "text-blue-700 dark:text-blue-300" },
  S2: { label: "Content Creation",            color: "#8B5CF6", bg: "bg-violet-100 dark:bg-violet-900/30", text: "text-violet-700 dark:text-violet-300" },
  S3: { label: "Blog & SEO",                  color: "#10B981", bg: "bg-emerald-100 dark:bg-emerald-900/30", text: "text-emerald-700 dark:text-emerald-300" },
  S4: { label: "Offers & Landing Pages",      color: "#F59E0B", bg: "bg-amber-100 dark:bg-amber-900/30",  text: "text-amber-700 dark:text-amber-300" },
  S5: { label: "Distribution & Deployment",   color: "#06B6D4", bg: "bg-cyan-100 dark:bg-cyan-900/30",    text: "text-cyan-700 dark:text-cyan-300" },
  S6: { label: "Analytics & Optimization",    color: "#F43F5E", bg: "bg-rose-100 dark:bg-rose-900/30",    text: "text-rose-700 dark:text-rose-300" },
  S7: { label: "Automation & Scale",          color: "#6366F1", bg: "bg-indigo-100 dark:bg-indigo-900/30", text: "text-indigo-700 dark:text-indigo-300" },
  S8: { label: "Meta",                        color: "#64748B", bg: "bg-slate-100 dark:bg-slate-800/60",  text: "text-slate-600 dark:text-slate-400" },
};

export const ALL_SKILLS: CCBSkill[] = [
  // S1
  { stage: "S1", slug: "affiliate-program-search",  label: "Affiliate Program Search",  description: "Research & score programs from list.affitor.com" },
  { stage: "S1", slug: "niche-opportunity-finder",  label: "Niche Opportunity Finder",  description: "Find underserved niches with high potential" },
  { stage: "S1", slug: "competitor-spy",             label: "Competitor Spy",             description: "Analyze competitor affiliate strategies + engagement" },
  { stage: "S1", slug: "commission-calculator",      label: "Commission Calculator",      description: "Calculate and compare commission structures" },
  { stage: "S1", slug: "monopoly-niche-finder",      label: "Monopoly Niche Finder",      description: "Find intersection niches where you're the ONLY voice (Thiel)" },
  { stage: "S1", slug: "purple-cow-audit",           label: "Purple Cow Audit",           description: "Score product remarkability 1-10 before promoting (Godin)" },
  { stage: "S1", slug: "trending-content-scout",     label: "Trending Content Scout",     description: "Scan YouTube/TikTok/X/Reddit for top content by engagement", isNew: true },
  { stage: "S1", slug: "content-angle-ranker",       label: "Content Angle Ranker",       description: "Rank angles by competition, engagement, platform fit", isNew: true },
  { stage: "S1", slug: "traffic-analyzer",           label: "Traffic Analyzer",           description: "Analyze website traffic, rank, sources. Evaluate advertiser health", isNew: true },
  // S2
  { stage: "S2", slug: "viral-post-writer",          label: "Viral Post Writer",          description: "LinkedIn, X, Reddit, Facebook posts with data-driven format selection" },
  { stage: "S2", slug: "twitter-thread-writer",      label: "Twitter Thread Writer",      description: "Multi-tweet threads with hooks" },
  { stage: "S2", slug: "reddit-post-writer",         label: "Reddit Post Writer",         description: "Authentic Reddit posts with disclosure" },
  { stage: "S2", slug: "tiktok-script-writer",       label: "TikTok Script Writer",       description: "Short-form video scripts with top performer analysis" },
  { stage: "S2", slug: "content-pillar-atomizer",    label: "Content Pillar Atomizer",    description: "1 article → 15-30 platform-native pieces" },
  { stage: "S2", slug: "content-research-brief",     label: "Content Research Brief",     description: "Collect sources, extract stats, generate research-backed angles", isNew: true },
  { stage: "S2", slug: "infographic-generator",      label: "Infographic Generator",      description: "Branded infographic specs from any content — LinkedIn-optimized", isNew: true },
  // S3
  { stage: "S3", slug: "affiliate-blog-builder",     label: "Affiliate Blog Builder",     description: "Full review and how-to articles" },
  { stage: "S3", slug: "comparison-post-writer",     label: "Comparison Post Writer",     description: "Head-to-head product comparisons" },
  { stage: "S3", slug: "listicle-generator",         label: "Listicle Generator",         description: "'Top N' roundup articles" },
  { stage: "S3", slug: "how-to-tutorial-writer",     label: "How-To Tutorial Writer",     description: "Tutorial articles with product integration" },
  { stage: "S3", slug: "keyword-cluster-architect",  label: "Keyword Cluster Architect",  description: "Map 50-200+ keywords into topical clusters" },
  { stage: "S3", slug: "content-moat-calculator",    label: "Content Moat Calculator",    description: "Estimate pages needed for topical authority" },
  { stage: "S3", slug: "content-decay-detector",     label: "Content Decay Detector",     description: "Monitor content for ranking drops, trigger refresh" },
  // S4
  { stage: "S4", slug: "landing-page-creator",       label: "Landing Page Creator",       description: "AIDA-framework landing pages" },
  { stage: "S4", slug: "product-showcase-page",      label: "Product Showcase Page",      description: "Single-product showcase" },
  { stage: "S4", slug: "squeeze-page-builder",       label: "Squeeze Page Builder",       description: "Lead capture pages" },
  { stage: "S4", slug: "webinar-registration-page",  label: "Webinar Registration Page",  description: "Event-based promotion" },
  { stage: "S4", slug: "grand-slam-offer",           label: "Grand Slam Offer",           description: "Hormozi Value Equation offer design" },
  { stage: "S4", slug: "bonus-stack-builder",        label: "Bonus Stack Builder",        description: "Exclusive bonus packages for YOUR link" },
  { stage: "S4", slug: "guarantee-generator",        label: "Guarantee Generator",        description: "Personal guarantees for risk reversal" },
  { stage: "S4", slug: "value-ladder-architect",     label: "Value Ladder Architect",     description: "Free → tripwire → core → upsell journey" },
  // S5
  { stage: "S5", slug: "bio-link-deployer",          label: "Bio Link Deployer",          description: "Linktree alternative you own" },
  { stage: "S5", slug: "email-drip-sequence",        label: "Email Drip Sequence",        description: "5-7 email nurture sequence" },
  { stage: "S5", slug: "social-media-scheduler",     label: "Social Media Scheduler",     description: "Posting schedule and calendar" },
  { stage: "S5", slug: "github-pages-deployer",      label: "GitHub Pages Deployer",      description: "Deploy to GitHub Pages" },
  // S6
  { stage: "S6", slug: "conversion-tracker",         label: "Conversion Tracker",         description: "UTM links, tracking pixels, attribution" },
  { stage: "S6", slug: "ab-test-generator",          label: "A/B Test Generator",         description: "A/B test variants for headlines and CTAs" },
  { stage: "S6", slug: "performance-report",         label: "Performance Report",         description: "Weekly/monthly KPI reports" },
  { stage: "S6", slug: "seo-audit",                  label: "SEO Audit",                  description: "10-dimension SEO scorecard" },
  { stage: "S6", slug: "internal-linking-optimizer", label: "Internal Linking Optimizer", description: "Hub-and-spoke internal link structure" },
  // S7
  { stage: "S7", slug: "email-automation-builder",   label: "Email Automation Builder",   description: "Branching email flows with conditions" },
  { stage: "S7", slug: "content-repurposer",         label: "Content Repurposer",         description: "One piece of content → multiple formats" },
  { stage: "S7", slug: "multi-program-manager",      label: "Multi-Program Manager",      description: "Affiliate program portfolio strategy" },
  { stage: "S7", slug: "paid-ad-copy-writer",        label: "Paid Ad Copy Writer",        description: "Ad copy for Facebook, Google, TikTok" },
  { stage: "S7", slug: "proprietary-data-generator", label: "Proprietary Data Generator", description: "Original surveys, benchmarks, data moats" },
  // S8
  { stage: "S8", slug: "skill-finder",               label: "Skill Finder",               description: "Find the right skill for any goal" },
  { stage: "S8", slug: "funnel-planner",             label: "Funnel Planner",             description: "Plan a complete affiliate funnel roadmap" },
  { stage: "S8", slug: "compliance-checker",         label: "Compliance Checker",         description: "FTC compliance and platform rules audit" },
  { stage: "S8", slug: "self-improver",              label: "Self-Improver",              description: "Campaign retrospective and improvement plan" },
  { stage: "S8", slug: "category-designer",          label: "Category Designer",          description: "Define a new category where your product wins" },
];

const s = (slug: string) => ALL_SKILLS.find(sk => sk.slug === slug)!;

export type StudioTab =
  | "diagram" | "stories" | "kanban" | "timeline" | "velocity" | "analysis"
  | "documents" | "stakeholders" | "requirements" | "compliance" | "agent-log"
  | "knowledge-base" | "team" | "schedule" | "test-cases" | "test-runner"
  | "impact-analysis" | "case-studies" | "genius-labs" | "handover"
  | "job-intelligence" | "evolution-log" | "capa" | "suppliers" | "traceability";

export const TAB_SKILL_MAP: Record<StudioTab, { skills: CCBSkill[]; why: string }> = {
  "diagram": {
    why: "Flows & journeys built with these skills → diagram them here",
    skills: [s("email-automation-builder"), s("funnel-planner"), s("value-ladder-architect")],
  },
  "stories": {
    why: "Nurture sequences = user journeys with discrete steps & acceptance criteria",
    skills: [s("email-drip-sequence"), s("email-automation-builder")],
  },
  "kanban": {
    why: "Deployment & distribution tasks are the execution work on this board",
    skills: [s("bio-link-deployer"), s("github-pages-deployer"), s("social-media-scheduler")],
  },
  "timeline": {
    why: "Publishing calendar + funnel phases map directly to Gantt rows",
    skills: [s("social-media-scheduler"), s("funnel-planner")],
  },
  "velocity": {
    why: "Weekly/monthly KPI report = campaign velocity equivalent",
    skills: [s("performance-report"), s("conversion-tracker")],
  },
  "analysis": {
    why: "Every research, scoring, and competitor output is an archived analysis",
    skills: [
      s("niche-opportunity-finder"), s("competitor-spy"), s("commission-calculator"),
      s("monopoly-niche-finder"), s("content-angle-ranker"), s("traffic-analyzer"),
      s("content-moat-calculator"), s("conversion-tracker"),
    ],
  },
  "documents": {
    why: "All content creation outputs (posts, articles, pages, scripts) are deliverable documents",
    skills: [
      s("viral-post-writer"), s("twitter-thread-writer"), s("reddit-post-writer"),
      s("tiktok-script-writer"), s("content-research-brief"), s("infographic-generator"),
      s("affiliate-blog-builder"), s("comparison-post-writer"), s("listicle-generator"),
      s("how-to-tutorial-writer"), s("landing-page-creator"), s("product-showcase-page"),
      s("squeeze-page-builder"), s("webinar-registration-page"), s("email-drip-sequence"),
      s("paid-ad-copy-writer"), s("content-repurposer"),
    ],
  },
  "stakeholders": {
    why: "Affiliate program managers and partner brands = external stakeholders",
    skills: [s("multi-program-manager"), s("affiliate-program-search")],
  },
  "requirements": {
    why: "Define WHAT to promote/build before execution — scope and success criteria",
    skills: [
      s("niche-opportunity-finder"), s("purple-cow-audit"), s("grand-slam-offer"),
      s("bonus-stack-builder"), s("keyword-cluster-architect"), s("content-moat-calculator"),
      s("category-designer"),
    ],
  },
  "compliance": {
    why: "FTC disclosure rules + legal guarantee language = compliance requirements",
    skills: [s("compliance-checker"), s("guarantee-generator")],
  },
  "knowledge-base": {
    why: "Long-form reference content that survives beyond a single campaign",
    skills: [
      s("content-pillar-atomizer"), s("how-to-tutorial-writer"), s("affiliate-blog-builder"),
      s("proprietary-data-generator"), s("content-repurposer"),
    ],
  },
  "agent-log": {
    why: "Every AI skill run = one agent action. All 52 skills produce loggable outputs",
    skills: [s("skill-finder"), s("funnel-planner"), s("self-improver")],
  },
  "test-cases": {
    why: "A/B variants and SEO dimension audits = structured test cases",
    skills: [s("ab-test-generator"), s("seo-audit")],
  },
  "test-runner": {
    why: "Running tracking pixels + live A/B experiments = test execution",
    skills: [s("conversion-tracker"), s("ab-test-generator")],
  },
  "impact-analysis": {
    why: "Content decay = impact of time/algorithm change on rankings",
    skills: [s("content-decay-detector"), s("seo-audit")],
  },
  "case-studies": {
    why: "Winning campaigns + category framing → package as case studies",
    skills: [s("comparison-post-writer"), s("category-designer"), s("performance-report")],
  },
  "handover": {
    why: "Deployed pages and live links = handover artifacts for client/next team",
    skills: [s("bio-link-deployer"), s("github-pages-deployer")],
  },
  "evolution-log": {
    why: "Track what changed in campaigns — decay detected → refresh logged",
    skills: [s("content-decay-detector"), s("self-improver")],
  },
  "traceability": {
    why: "Internal link structure = traceability between content pieces and conversion intent",
    skills: [s("internal-linking-optimizer"), s("keyword-cluster-architect")],
  },
  "capa": {
    why: "Campaign retrospective + SEO fix = Corrective and Preventive Action",
    skills: [s("self-improver"), s("seo-audit"), s("content-decay-detector")],
  },
  "suppliers": {
    why: "Affiliate programs on list.affitor.com = your supplier/vendor list",
    skills: [s("affiliate-program-search"), s("multi-program-manager")],
  },
  "team": {
    why: "Assign which team member runs which skill in each sprint",
    skills: [s("multi-program-manager"), s("funnel-planner")],
  },
  "schedule": {
    why: "Publishing calendar + funnel milestones = team schedule",
    skills: [s("social-media-scheduler"), s("funnel-planner")],
  },
  "job-intelligence": {
    why: "Platform trends, competitor moves, traffic signals = market intelligence",
    skills: [s("trending-content-scout"), s("competitor-spy"), s("traffic-analyzer")],
  },
  "genius-labs": {
    why: "Thiel monopoly thinking, Godin remarkability, original data — experimental strategic tools",
    skills: [s("skill-finder"), s("monopoly-niche-finder"), s("purple-cow-audit"), s("proprietary-data-generator")],
  },
};
